//modified version of https://github.com/mistic100/three.js-examples/blob/master/examples/js/interactive/SelectionHelper.js to suit our needs
import WorkspaceManager from './WorkspaceManager';
import Input from '../classes/Input';
import store from '../state/store';

export default class SelectionHelper
{
	constructor()
	{
		this.element = document.createElement("div");
		this.element.classList.add('selectBox');
		this.element.style.pointerEvents = "none";
		this.startPoint = { x: 0, y: 0 };
		this.pointTopLeft = { x: 0, y: 0 };
		this.pointBottomRight = { x: 0, y: 0 };
		this.boundingRect = null;
	}

	onSelectstart()
	{
		const hoveredWindowId = store.getState().workspaceModule.hoveredWindowId;
		const sceneViewData = WorkspaceManager.getSceneViewData(hoveredWindowId);
		const domElement = sceneViewData.context.canvas;
		domElement.parentElement.appendChild(this.element);
		this.boundingRect = domElement.getBoundingClientRect();

		const mousePos = Input.getMousePositionRaw();
		this.element.style.left = mousePos.x + "px";
		this.element.style.top = mousePos.y + "px";
		this.element.style.width = "0px";
		this.element.style.height = "0px";

		this.startPoint.x = mousePos.x;
		this.startPoint.y = mousePos.y;
	}

	onSelectMove()
	{
		const mousePos = Input.getMousePositionRaw();
		this.pointBottomRight.x = Math.min(Math.max(this.startPoint.x, mousePos.x), this.boundingRect.right);
		this.pointBottomRight.y = Math.min(Math.max(this.startPoint.y, mousePos.y), this.boundingRect.bottom);
		this.pointTopLeft.x = Math.max(Math.min(this.startPoint.x, mousePos.x), this.boundingRect.left);
		this.pointTopLeft.y = Math.max(Math.min(this.startPoint.y, mousePos.y), this.boundingRect.top);

		this.element.style.left = this.pointTopLeft.x + "px";
		this.element.style.top = this.pointTopLeft.y + "px";
		this.element.style.width = (this.pointBottomRight.x - this.pointTopLeft.x) + "px";
		this.element.style.height = (this.pointBottomRight.y - this.pointTopLeft.y) + "px";
	}

	onSelectOver()
	{
		if (this.element.parentElement != null)
		{
			this.element.parentElement.removeChild(this.element);
		}
	}
}
